<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>mdi-chat-plus-outline</v-icon>
        <span class="m-l-5">TTS cache</span>
        <v-tooltip :max-width="350" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" class="m-l-10">
              fa-info-circle
            </v-icon>
          </template>
          <div>
            Generate TTS but does not make sound. This is useful when trying to
            pre-generate TTS a few seconds in advance so that subsequent TTS
            with the same text can be played smoothly.
          </div>
        </v-tooltip>
      </div>
      <div>
        <v-progress-circular
          v-if="ttsLoading"
          indeterminate
          :size="16"
          :width="2"
        ></v-progress-circular>
        <v-icon v-else small :disabled="!prompt.text" @click="playPrompt">
          {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
        </v-icon>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <v-textarea
      v-model="prompt.text"
      label="Enter text"
      class="textarea-input no-drag"
      solo
      hide-details
      rows="2"
      row-height="20"
      @keyup.down="pressDown"
      @keyup.up="pressUp"
      @keydown.enter="onEnter"
      @keydown.tab="pressTab"
    ></v-textarea>
    <!-- === use for Intellisense ===-->
    <intellisense-component
      :input="prompt.text"
      :start="start"
      :drawFlowItems="drawFlowItems"
      :property="'tts'"
      :apiForIntellisense="apiForIntellisense"
      :eventKey="eventKey"
      @clearSelected="clearSelected"
      @updateInputFromIntellisense="updateInputFromIntellisense"
    />
    <!-- === use for Intellisense ===-->
    <v-text-field
      v-if="isMetaverse"
      v-model="prompt.video"
      label="Video URL (optional)"
      class="m-t-20 m-b-10"
      hide-details
      dense
    ></v-text-field>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import apiSynthesis from '@/apis/synthesis'
// === use for Intellisense ===
import IntellisenseComponent from '../../../../components/intellisense'
// === use for Intellisense ===
export default {
  name: 'PayloadTts',
  props: {
    items: Array,
    index: Number,
    prompt: Object,
    minioHost: String,
    ttsProperty: Object,
    isMainPlaying: Boolean,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  // === use for Intellisense ===
  components: {
    IntellisenseComponent
  },
  // === use for Intellisense ===
  data() {
    return {
      previewVoice: '',
      isPlaying: false,
      start: -1,
      isKeyTab: false,
      ttsLoading: false,
      isMetaverse: process.env.VUE_APP_METAVERSE === 'true',
      // === use for Intellisense ===,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  watch: {
    isMainPlaying: {
      handler(val) {
        if (this.isMainPlaying) {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      }
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })
  },
  methods: {
    async playPrompt() {
      try {
        if (!this.isPlaying) {
          this.ttsLoading = true

          const tts = await apiSynthesis.synthesis({
            ...this.ttsProperty,
            text: this.prompt.text,
            useCache: true
          })
          this.previewVoice = tts.data.audio

          this.$refs.myAudio.load()

          setTimeout(() => {
            this.$refs.myAudio.play()
            this.ttsLoading = false
          }, 300)
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    isSubPlaying() {
      this.$emit('isSubPlaying', null)
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      //ใช้เช็คว่า ถ้าเรากดเลือก list อยู่จะไม่ขึ้น Newline
      if (e.keyCode === 13 && this.start > -1) {
        //ใช้เช็คว่า ถ้าเรากดเลือก list อยู่จะไม่ขึ้น Newline
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      //ถ้าไม่ได้เลือก list จะ newline ทุกครั้งที่กด Enter
      this.eventKey = 'enter'
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.prompt.text = data
    },
    // === use for Intellisense ===
    clearSelected() {
      this.start = -1
    }
  }
}
</script>

<style scoped lang="scss">
.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}
.voice-header {
  display: flex;
  justify-content: space-between;
}
</style>
